import { FC, useEffect, useState } from 'react';

import * as Meta from 'meta';
import * as API from 'api';

import * as Type from './type';

import { Header, Footer } from "components";

/** @describe 要串資料哦 */
export const WinnerPage: FC = () => {

  const [winnerList, setWinnerList] = useState<Type.WinnerList>({part1: {}, part2: []});

  useEffect(() => {
    fetch(API.winnerList())
      .then(res => res.json())
      .then(setWinnerList);
  }, []);

  const { part1, part2 } = winnerList;

  return (
    <div className="wrapper">
      {Meta.loadCSS(["award", "notice"])}
      {Meta.loadJS(["main-0625"])}
      {Meta.ga("得獎公告頁")}
      <Header />
      <div className="main">
        <div className="page_text mt">得獎公告</div>
        <section className="award inner">
          <div className="award_titlebox mr">
            <div className="award_circle">
              <span>暢快爽勁<br />第<span className="special">1</span>發</span>
            </div>
            <div className="award_title">
              <span>爽爽好禮即掃即抽<br />【爽啤X油頭二世】限量獨家好禮</span>
            </div>
          </div>

          {Object.keys(part1).map(key =>
            <div key={key} className="award_box">
              <div className="award_name">{part1[key].name}</div>
              <table className="award_table_top">
                <thead>
                  <tr>
                    <th className="award_l">抽獎日期</th>
                    <th className="award_c">中獎人</th>
                    <th className="award_r">中獎者電話</th>
                  </tr>
                </thead>
              </table>
              <div className="table_over">
                <table className="award_table_in">
                  <tbody>
                    {part1[key].list.map(winner =>
                      <tr key={winner.id}>
                        <td>{winner.time}</td>
                        <td className="award_n">{winner.name}</td>
                        <td>{winner.phone}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="award_titlebox mr">
            <div className="award_circle">
              <span>暢快爽勁<br /><span className="special num">2</span>連發</span>
            </div>
            <div className="award_title">
              <span>最爽好禮週週抽<br />【時尚生活X享樂人生】大禮</span>
            </div>
          </div>

          <div className="award_box">
            <table className="award_table2_top">
              <thead>
                <tr>
                  <th className="award_l">抽獎日期</th>
                  <th className="award_c">獎項</th>
                  <th className="award_c">中獎人</th>
                  <th className="award_r">中獎者電話</th>
                </tr>
              </thead>
            </table>
            <div className="table_over">
              <table className="award_table2_in">
                <tbody>
                  {part2.map(loserKing =>
                    <tr id={loserKing.id}>
                      <td>{loserKing.date}</td>
                      <td className="award_n">{loserKing.prize}</td>
                      <td className="award_n">{loserKing.loser_name}</td>
                      <td>{loserKing.loser_phone}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section className="award_notice">
          <div className="inner">
            <div className="title">
              <div className="title_t">得獎注意事項</div>
              <div className="title_bg"><img src="/resources/html/images/title_bg.png" /></div>
            </div>
            <ul className="award_notiocin">
              <li>
                <span className="award_num">(1)</span>
                「中獎確認函」會自動寄送至中獎人留存之電子郵件信箱，須自行下載、列印並填妥後，於2021年 8月20日前將中獎確認函(內含同意書)以掛號郵寄、掃描電子檔Email、傳真等方式擇一，提供至「我的暢快爽勁」活動小組，方可完成兌獎手續(以郵戳/傳送時間為憑)，逾期視同自動放棄權利。
              </li>
              <li>
                <span className="award_num">(2)</span>
                中獎獎項單價價值累計新台幣1,001～20,001元者，依所得稅法規定需申報收入，請兌獎者／中獎者須將中獎確認函(附上身分證正反面影本)填妥後於2021年 8月20日前以掛號郵寄、掃描Email或傳真等方式擇一，提供至「我的暢快爽勁」活動小組，方可完成領獎手續(以郵戳/傳送時間為憑)，逾期視同自動放棄權利。
              </li>
              <li>
                <span className="award_num">(3)</span>
                若活動小組在2021年8月20日前無法成功聯繫得獎者，將視同得獎者放棄中獎資格，活動小組則不再另行通知，且不再遞補中獎者。
              </li>
              <li>
                <span className="award_num">(4)</span>
                所有獎項統一於2021年8月23日後陸續寄出。
              </li>
            </ul>
          </div>
        </section>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>
  );
};
